<dashboard-loader *ngIf="isLoadingSection$ | async" [title]="'Loading section...'"></dashboard-loader>
<div *ngIf="sectionLoaded$ | async" class="cc-material-theme dashboard-section-dialog">
  <dashboard-dialog-title></dashboard-dialog-title>
  <mat-dialog-content class="dashboard-section-dialog__content">
    <form [formGroup]="sectionForm" dashboardConnectForm [connectForm]="isEdit ? selectedSection : null">
      <div fxLayout="row" fxLayoutAlign="space-around start" fxLayoutGap="20px">
        <div
          class="dashboard-section-dialog__content__left"
          fxLayout="column"
          fxLayoutAlign="space-around start"
          fxLayoutGap="20px"
          fxFlex="40"
        >
          <h1 class="dashboard-section-dialog__content__left-title">Section</h1>
          <div fxLayout="column" fxLayoutAlign="space-between" fxFill fxLayoutGap="10px">
            <dashboard-section-dialog-core formControlName="sectionDialogCore"></dashboard-section-dialog-core>
            <dashboard-image-upload
              *ngIf="sectionDialogCore?.value?.type === SectionType.GENERIC_GRAPH"
              formControlName="imageUrl"
              [label]="'Generic graph section image'"
              [isEdit]="isEdit"
              [isImageToEdit]="isImageToEdit"
              [imgPath]="imgPath"
              [keyForUpload]="keyForUpload"
              [idsForUpload]="idsForUpload"
              [size]="IMAGE_SIZES.MEDIUM"
            >
            </dashboard-image-upload>
            <div fxLayout="row" fxLayoutAlign="end">
              <button
                *ngIf="
                  sectionDialogCore?.value?.type &&
                  sectionDialogCore?.value?.type !== SectionType.DESCRIPTION &&
                  !sectionCoreFormSubmitted &&
                  !isEdit
                "
                mat-raised-button
                color="accent"
                (click)="saveSection()"
              >
                {{ 'Continue' | uppercase }}
              </button>
            </div>
            <dashboard-subsections-list
              [iconUuid]="subsectionIconUuid"
              [isImageToEdit]="isIconToEdit"
              (subsectionChanged)="prepareConfiguration($event)"
            ></dashboard-subsections-list>
          </div>
        </div>
        <div class="dashboard-section-dialog__content__center">
          <div class="dashboard-section-dialog__content__center-line"></div>
        </div>
        <div
          class="dashboard-section-dialog__content__right"
          fxLayout="column"
          fxLayoutAlign="space-around stretch"
          fxLayoutGap="40px"
          fxFlex="50"
        >
          <div *ngIf="sectionDialogCore?.value?.type">
            <mat-tab-group
              mat-stretch-tabs
              dynamicHeight
              #tabs
              class="dashboard-template__right-group"
              fxLayout="column"
              fxLayoutAlign="center"
              fxFill
              (selectedTabChange)="tabChanged($event)"
            >
              <mat-tab label="GENERAL">
                <dashboard-description-section
                  *ngIf="sectionDialogCore?.value?.type === SectionType.DESCRIPTION && generalTabActive"
                  formControlName="descriptionSection"
                >
                </dashboard-description-section>
                <dashboard-generic-graph
                  *ngIf="
                    sectionDialogCore?.value?.type === SectionType.GENERIC_GRAPH &&
                    selectedSubsection &&
                    generalTabActive
                  "
                  [iconUuid]="subsectionIconUuid"
                  (resetSubsection)="resetSubsection($event)"
                >
                </dashboard-generic-graph>
                <dashboard-profile
                  *ngIf="
                    sectionDialogCore?.value?.type === SectionType.PROFILE && selectedSubsection && generalTabActive
                  "
                  [iconUuid]="subsectionIconUuid"
                  (resetSubsection)="resetSubsection($event)"
                >
                </dashboard-profile>
                <dashboard-dimension
                  *ngIf="
                    sectionDialogCore?.value?.type === SectionType.DIMENSION && selectedSubsection && generalTabActive
                  "
                  [iconUuid]="subsectionIconUuid"
                  (resetSubsection)="resetSubsection($event)"
                >
                </dashboard-dimension>
              </mat-tab>
              <mat-tab
                *ngIf="
                  sectionDialogCore?.value?.type === SectionType.PROFILE ||
                  sectionDialogCore?.value?.type === SectionType.DIMENSION
                "
                label="CONFIGURATION"
                [disabled]="!selectedSubsection?.id"
              >
                <dashboard-profile-configuration
                  *ngIf="sectionDialogCore?.value?.type === SectionType.PROFILE && selectedSubsection?.id"
                  (configurationSaved)="setIsConfigurationSaved($event)"
                >
                </dashboard-profile-configuration>
                <dashboard-dimension-configuration
                  *ngIf="sectionDialogCore?.value?.type === SectionType.DIMENSION && selectedSubsection?.id"
                  (configurationSaved)="setIsConfigurationSaved($event)"
                >
                </dashboard-dimension-configuration>
              </mat-tab>
            </mat-tab-group>
            <div
              class="dashboard-section-dialog__content__right-button"
              fxLayout="column"
              fxLayoutAlign="end end"
              fxFill
            >
              <button
                *ngIf="sectionDialogCore?.value?.type === SectionType.DESCRIPTION"
                mat-raised-button
                color="accent"
                (click)="saveDescriptionSection()"
              >
                {{ 'Save Section' | uppercase }}
              </button>
              <button
                *ngIf="sectionDialogCore?.value?.type !== SectionType.DESCRIPTION && isEdit"
                mat-raised-button
                color="accent"
                [disabled]="isEditingItem || isEditingConfiguration"
                (click)="saveSection()"
              >
                {{ 'Save Section' | uppercase }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
</div>
